var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-backtop',{attrs:{"bottom":30,"right":20}},[_c('img',{attrs:{"src":"https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169260868004224705767340193963.svg","alt":""}})]),_vm._v(" "),_c('my-header',{ref:"myHeaderRef"}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('my-footer',{ref:"myFooterRef"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b745e38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 